import React from 'react'
import { useDispatch } from 'react-redux'
import {
    Card, Row, Col, Form as VendorForm
} from 'react-bootstrap'
import styled from 'styled-components'
import Select from 'react-select'

import { urlRegex, _ } from 'utils'
import { $gray_900 } from 'utils/colors'
import { useSpaceParams } from 'hooks'
import { showErrorNotification } from 'features/notifications/notificationsSlice'

import EditableEditorField from './FormFields/EditableEditorField'
import EditableImageField from './FormFields/EditableImageField'
import EditableTextField from './FormFields/EditableTextField'
import { Booth } from './types'
import useSaveBooth from './hooks/useSaveBooth'
import { upload } from './actions'

const S = {
    Form: styled(VendorForm)`
        padding: 20px 37px;
    `,

    Header: styled.h2`
        color: ${$gray_900};
        font-weight: bold;
        padding: 40px 40px 0 38px;
    `,
    Categories: styled(Select)`
        width: 100%;
        margin-bottom: 20px;
    `
}

const GeneralInfo = ({ booth, fetchBooth }: { booth: Booth, fetchBooth: () => void }) => {
    const {
        name,
        company_logo,
        subtitle,
        description,
        website,
    } = booth

    const dispatch = useDispatch()
    const saveBooth = useSaveBooth()
    const { eventSlug, spaceSlug } = useSpaceParams()

    const updateName = (value: string) => {
        saveBooth({ name: value })
    }
    const updateSubtitle = (value: string) => {
        saveBooth({ subtitle: value })
    }
    const updateDescription = (value: string) => {
        saveBooth({ description: value })
    }
    const updateCompanyLogo = (file: File) => {
        dispatch(upload({
            type: 'company_logo',
            eventSlug,
            boothSlug: spaceSlug,
            file,
        }))
    }
    const updateWebsite = (value: string, setValue) => {
        if (urlRegex.test(value)) {
            saveBooth({ website: value })
            fetchBooth()
            return
        }
        setValue(website)
        dispatch(showErrorNotification(_('form.validation.invalid_url')))
    }

    return (
        <Card>
            <S.Header>{_('booth.config.general_info.title')}</S.Header>
            <S.Form>
                <Row>
                    <Col md={4}>
                        <EditableTextField
                            defaultValue={name}
                            inputType="text"
                            label={_('booth.config.general_info.full_name')}
                            onUpdate={updateName}
                        />
                    </Col>
                    <Col md={4}>
                        <EditableTextField
                            defaultValue={website}
                            inputType="text"
                            label={_('booth.config.general_info.website')}
                            onUpdate={updateWebsite}
                        />
                    </Col>
                    <Col md={4}>
                        <EditableImageField
                            defaultValue={company_logo}
                            label={_('booth.config.general_info.company_logo')}
                            replaceLinkText={_('booth.config.general_info.upload_company_logo')}
                            onUpdate={updateCompanyLogo}
                        />
                    </Col>
                </Row>

                <EditableTextField
                    defaultValue={subtitle}
                    inputType="textarea"
                    label={_('booth.config.general_info.subtitle')}
                    onUpdate={updateSubtitle}
                />

                <EditableEditorField
                    defaultValue={description}
                    label={_('booth.config.general_info.description')}
                    onUpdate={updateDescription}
                />
            </S.Form>
        </Card>
    )
}

export default GeneralInfo
